import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const AdminImageAdd = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const categoryDisplayNames = {
  'restaurant': 'Restaurant',
  'chalet': 'Chalet',
  'musee': 'Musée',
  'huilerie': 'Huilerie',
  'academie': 'Académie',
  'terroir': 'Terroir Numidya',
  'clublespins': 'Club Les Pins'
};
  const [files, setFiles] = useState([]);
  const [category, setCategory] = useState('');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [images, setImages] = useState([]);
  const [editingImage, setEditingImage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const resetForm = () => {
  setEditingImage(null); 
  setFiles([]);           
  setCategory('');   
  setSuccess('');
  setError('');
};


  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const { data, error } = await supabase
        .from('category_images')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      setImages(data);
    } catch (err) {
      console.error('Erreur:', err);
      setError(err.message);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentImages = images.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(images.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
    setError('');
    setSuccess('');
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!editingImage && (files.length === 0 || !category)) {
      setError('Veuillez sélectionner des images et une catégorie');
      return;
    }

    setUploading(true);
    setError('');
    setSuccess('');

    try {
      const { data: { user }, error: authError } = await supabase.auth.getUser();
      if (authError || !user) throw new Error('Authentification requise');

      if (editingImage) {
        const { error } = await supabase
          .from('category_images')
          .update({ category })
          .eq('id', editingImage.id);

        if (error) throw error;
        setSuccess("Image mise à jour avec succès");
        setEditingImage(null);
      } else {
        const uploadPromises = files.map(async (file) => {
          const fileExt = file.name.split('.').pop();
          const fileName = `${category}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}.${fileExt}`;
          const filePath = `${category}/${fileName}`;

          const { error: uploadError } = await supabase.storage
            .from('category-images')
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          const { data: { publicUrl } } = supabase.storage
            .from('category-images')
            .getPublicUrl(filePath);

          const { error: insertError } = await supabase
            .from('category_images')
            .insert({
              url: publicUrl,
              category,
              user_id: user.id,
              file_name: fileName
            });

          if (insertError) throw insertError;
          return publicUrl;
        });

        await Promise.all(uploadPromises);
        setSuccess(`${files.length} images téléchargées avec succès pour "${category}"`);
      }

      setFiles([]);
      setCategory('');
      fetchImages();
      setCurrentPage(1); 
    } catch (err) {
      console.error('Erreur:', err);
      setError(err.message);
    } finally {
      setUploading(false);
    }
  };

  const handleEdit = (image) => {
    setEditingImage(image);
    setCategory(image.category);
    setSuccess('');
    setError('');
  };

  const handleDelete = async (image) => {
    if (window.confirm('Confirmer la suppression de cette image ?')) {
      try {
        const { error } = await supabase
          .from('category_images')
          .delete()
          .eq('id', image.id);
        if (error) throw error;

        await supabase
          .storage
          .from('category-images')
          .remove([`${image.category}/${image.file_name}`]);

        setSuccess('Image supprimée avec succès');
        fetchImages();
      } catch (err) {
        console.error('Erreur:', err);
        setError(err.message);
      }
    }
  };

  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3 className="page-title">Images par catégorie</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item" style={{color: "#0063cc"}}>Tables</li>
            <li className="breadcrumb-item active" aria-current="page">Images</li>
          </ol>
        </nav>
      </div>

      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{editingImage ? "Modifier une image" : "Ajouter des images"} <label>(multi-sélection)</label></h4>
              <form className="forms-sample" onSubmit={handleSubmit}>
              {!editingImage && (
  <div className="form-group">
    <label>Images</label>
    <div className="file-input-container">
      <input
        type="file"
        className="file-input"
        id="categoryImages"
        name="images"
        accept="image/*"
        onChange={handleFileChange}
        multiple
      />
      <label htmlFor="categoryImages" className="file-input-label">
        <span className="file-input-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="17 8 12 3 7 8"></polyline>
            <line x1="12" y1="3" x2="12" y2="15"></line>
          </svg>
        </span>
        <span className="file-input-text">
          {files.length > 0 ? `${files.length} fichier(s) sélectionné(s)` : "Choisir des fichiers"}
        </span>
      </label>
    </div>
  </div>
)}
                <div className="form-group">
                  <label htmlFor="category">Catégorie</label>
                  <select
                    className="form-control"
                    id="category"
                    value={category}
                    onChange={handleCategoryChange}
                    required
                  >
                     <option value="">-- Sélectionner --</option>
  {Object.keys(categoryDisplayNames).map(key => (
    <option key={key} value={key}>
      {categoryDisplayNames[key]}
    </option>
  ))}
                  </select>
                </div>

                {error && <div className="alert alert-danger mt-2">❌ {error}</div>}
                {success && <div className="alert alert-success mt-2">✅ {success}</div>}

                <button type="submit" className="btn btn-primary mr-2" disabled={uploading}>
                  {uploading ? 'Téléchargement...' : editingImage ? 'Mettre à jour' : 'Ajouter les images'}
                </button> 
                {editingImage && (
            <button type="button" className="btn btn-dark" onClick={resetForm}>
              Annuler
              </button>
                )}

                
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Liste des images */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Liste des images</h4>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>Catégorie</th>
                      <th>Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentImages.map(image => (
                      <tr key={image.id}>
                        <td>
                          <img src={image.url} alt="Uploaded" style={{ width: '50px',height: '50px', objectFit: 'cover', borderRadius: '50%' }} />
                        </td>
                        <td>{categoryDisplayNames[image.category]}</td>
                        <td>{new Date(image.created_at).toLocaleString()}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-primary mr-2"
                            onClick={() => {handleEdit(image); scrollToTop();}}
                          >
                            Modifier
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(image)}
                          >
                            Supprimer
                          </button>
                        </td>
                      </tr>
                    ))}
                    {images.length === 0 && (
                      <tr>
                        <td colSpan="4" className="text-center">Aucune image trouvée</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                
                {images.length > 0 && (
                  <nav aria-label="Page navigation" className="mt-4">
                    <ul className="pagination justify-content-center">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={goToPreviousPage} aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                      </li>
                      
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                          <button className="page-link" onClick={() => paginate(page)}>
                            {page}
                          </button>
                        </li>
                      ))}
                      
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={goToNextPage} aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminImageAdd;